<div class="lp-my-product-codes">
  <lp-my-product-codes-header
    [title]="'components.loyaltyLpMyProductCodes.labels.myProductCodes' | translate"
  ></lp-my-product-codes-header>

  <tui-scrollbar>
    <app-loader-wrapper [loading]="loading">
      <ng-container *ngIf="productCodes">
        <lp-no-data-found
          *ngIf="productCodes && !productCodes.length"
          [title]="'components.loyaltyLpMyProductCodes.labels.noData' | translate"
          [hideIcon]="true"
          [hideSubtitle]="true"
        ></lp-no-data-found>
      </ng-container>

      <div class="lp-my-product-codes__products">
        <div class="lp-my-product-codes__products_wrapper">
          <ng-container *ngIf="productCodes">
            <lp-product-code-card *ngFor="let code of productCodes" [code]="code"></lp-product-code-card>
          </ng-container>
        </div>
      </div>
    </app-loader-wrapper>
  </tui-scrollbar>
</div>
